import { action, observable } from "mobx";
import { Accommodation_Details, AccommodationCardDetailsFragment } from "@graphql";
import { store } from "@store";

export class AccommodationProfileStore {
  @observable tab = "events";
  @observable data: AccommodationCardDetailsFragment = null;
  @observable loading = false;
  @observable error: string;

  constructor(public readonly id: string) {
    (window as any).customerProfileStore = this;
    this.getAccommodationData(id);
  }

  @action handleTabChange = (value: string) => {
    this.tab = value;
  };

  @action getAccommodationData = async (id: string) => {
    try {
      this.loading = true;
      this.error = null;
      await Accommodation_Details.func({ id }, { fetchPolicy: "network-only" }).then(
        (res) => {
          this.data = res.data.getAccommodationDetails;
        }
      );
    } catch (e) {
      store().snackbars.error(`${e}`);
      this.error = e.toString();
    } finally {
      this.loading = false;
    }
  };
}
